<div class="flex h-screen bg-gray-100 font-sans selection:bg-indigo-100 relative">
  @if (authService.showTour()) {
    <app-tour (onComplete)="authService.dismissTour()" />
  }

  <!-- TODO: Lista de espera será desenvolvido em outro momento -->
  <!-- @if (showToast()) {
    <div
      class="fixed top-6 left-1/2 -translate-x-1/2 z-[300] animate-in fade-in slide-in-from-top-10 duration-500"
    >
      <div
        class="bg-slate-900 border border-emerald-500/30 text-white px-6 py-4 rounded-3xl shadow-2xl shadow-emerald-500/20 flex items-center gap-4 min-w-[320px]"
      >
        <div
          class="w-10 h-10 bg-emerald-500 rounded-2xl flex items-center justify-center shadow-lg shadow-emerald-500/40"
        >
          <lucide-icon [img]="icons.checkCircle2" class="w-6 h-6 text-white" />
        </div>
        <div class="flex-1">
          <p class="text-xs font-black uppercase tracking-widest text-emerald-400">
            Solicitacao Enviada!
          </p>
          <p class="text-[10px] text-slate-400 font-bold leading-tight mt-0.5">
            Incrivel! Detectamos seu interesse. Nosso time comercial entrara em contato em breve via
            WhatsApp.
          </p>
        </div>
        <button
          type="button"
          (click)="dismissToast()"
          class="p-1 hover:bg-white/5 rounded-lg transition"
          aria-label="Fechar toast"
        >
          <lucide-icon [img]="icons.x" class="w-4 h-4 text-slate-500" />
        </button>
      </div>
    </div>
  } -->

  <app-sidebar
    [activeView]="activeView()"
    [role]="role()"
    [currentUser]="currentUser()"
    (changeView)="changeView($event)"
    (toggleRole)="toggleRole($event)"
    (logout)="logout()"
  />

  <div class="flex-1 flex flex-col overflow-hidden">
    <app-header [notifications]="notifications()" (markAsRead)="markNotificationAsRead($event)" />

    <main class="flex-1 overflow-auto p-6 md:p-10 bg-gray-50/50">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
